import $ from "jquery";
/* eslint-disable
    camelcase,
    class-methods-use-this,
    consistent-return,
    default-case,
    func-names,
    no-multi-assign,
    no-new,
    no-param-reassign,
    no-return-assign,
    no-shadow,
    no-undef,
    no-underscore-dangle,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import ResponsiveVideos from "lib/tc/responsive_videos";
import GalleryHelpers from "lib/gallery_helpers";
import BasePage from "pages/base_page";
import rememberRegion from "lib/rememberRegion";
import renderEditorialActionsMenu from "lib/renderEditorialMenu";
import renderPromos from "../renderPromos";
import { track } from "../lib/analytics";

const EDITORIAL_ACTIONS_MENU_PATH = "/editorial/actions_menu/pages/:page_id";

let PagePage;

// PagePage contains the JS used on our pages#show views (ie. the home page and
// section pages). Our apologies for the vague name, but we felt it was important
// to follow our naming convention of ResourcePage for consistency.
export default PagePage = (function () {
  PagePage = class PagePage extends BasePage {
    static initClass() {
      this.prototype.events = {
        "click .social-media a.twitter": "_trackTwitter",
        "click .social-media a.facebook": "_trackFaceBook",
        "click .social-media a.linkedin": "_trackLinkedin",

        "click .page-layout.section article a": "_sectionArticleTracking",

        "click a.button.expand-gallery": "_loadGallery",
        "click a.button.close-gallery": "_closeGallery",
      };
    }

    initialize(options) {
      super.initialize(options);
      this._initGalleryExpansion();
      new ResponsiveVideos();
      rememberRegion();
      renderPromos();
      renderEditorialActionsMenu(EDITORIAL_ACTIONS_MENU_PATH.replace(":page_id", options.pageId));
    }

    _initGalleryExpansion() {
      this.galleryButton = $(".expand-gallery");
      if (this.galleryButton.length > 0) { return this.galleryUrl = this.galleryButton[0].href; }
    }

    _loadGallery(event) {
      event.preventDefault();
      GalleryHelpers.loadGallery(this.galleryUrl);
      return GalleryHelpers.disableScrollForBody();
    }

    _closeGallery(event) {
      event.stopPropagation();
      event.preventDefault();
      $("html, body").stop();
      GalleryHelpers.removeGallery();
      return GalleryHelpers.enableScrollForBody();
    }

    _isUS() {
      return $("body").is(".region_us");
    }

    _isAU() {
      return $("body").is(".region_au");
    }

    _isFR() {
      return $("body").is(".region_fr");
    }

    _isUK() {
      return $("body").is(".region_uk");
    }

    _isGlobal() {
      return $("body").is(".region_global");
    }

    _isHomepage() {
      return $("body").is(".pages-show-home-page") && !$("body").is(".pages-edit");
    }

    _isAfrica() {
      return $("body").is(".region_africa");
    }

    _isOldIE() {
      return $("html").is(".ie7, .ie8");
    }

    _trackTwitter(event) {
      this.link = $(event.currentTarget);
      return this._completeTracking("Social Media - clicks to our page", "Twitter", link);
    }

    _trackFaceBook(event) {
      this.link = $(event.currentTarget);
      return this._completeTracking("Social Media - clicks to our page", "Facebook", link);
    }

    _trackLinkedin(event) {
      this.link = $(event.currentTarget);
      return this._completeTracking("Social Media - clicks to our page", "Linkedin", link);
    }

    _completeTracking(title, description, link) {
      track(title, description, link.attr("href"), 1);
    }

    _sectionArticleTracking(event) {
      const link = $(event.currentTarget);
      // Get the page's name
      const page_name = link.parents(".page-layout.section").first().data("name");
      const article = link.closest("article");
      const page_area = article.closest(".page-area, .article-section");
      const article_section = article.closest(".article-section");

      const category_name = article_section.attr("id");
      // TODO: Figure out what this does, and refactor. This is ugly.
      const section_index = `0${$(".article-section").index(article_section) + 1}`.slice(-2);
      const area_index = `0${article_section.find(".page-area").index(page_area) + 1}`.slice(-2); // leading zero
      const article_index = `0${page_area.find("article").index(article) + 1}`.slice(-2); // leading zero

      const description = `${page_name}-${section_index}-${category_name}-${area_index}-${article_index}`;
      return this._completeTracking("Home/Section Page - Article clicks by position", description, link);
    }
  };
  PagePage.initClass();
  return PagePage;
}());
